/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface MessagingAccessToken { 
    /**
     * Name that identifies particular messaging platform in use
     */
    service_name: string;
    /**
     * Access token to propagate to messaging platform's SDK (usually, a JWT token)
     */
    access_token: string;
}